module.exports = __webpack_public_path__ + "img/debtPayingAbility4.5637c68a.png";